import styled from "@emotion/styled";
import { FC } from "react";

import { Button, Input, SpacingToken } from "@livechat/design-system-react-components";

import { CopyToClipboard } from "components/copy-to-clipboard-input";
import Flex from "components/layout/Flex";
import { withVar } from "themes/helpers";

interface IProps {
  inboxAddress: string;
  handleMailboxCopying: () => void;
}

export const ForwardingAddressCopy: FC<IProps> = ({ inboxAddress, handleMailboxCopying }) => {
  return (
    <Flex alignItems="center" justifyContent="space-between" width="100%" marginTop={withVar(SpacingToken.Spacing3)}>
      <InboxAddressInput disabled value={inboxAddress} />
      <CopyToClipboard value={inboxAddress} onCopiedHandler={handleMailboxCopying}>
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
        {({ handleCopy }: any) => (
          <Button kind="secondary" onClick={handleCopy}>
            Copy
          </Button>
        )}
      </CopyToClipboard>
    </Flex>
  );
};

const InboxAddressInput = styled(Input)`
  width: 100%;
  margin-right: ${withVar(SpacingToken.Spacing1)};
`;
